/** @format */

import { PostMethod } from "../api/Api";
import { getSession, setFileInfoData } from "../sessionStorage/sessionStorageMethod";
import { initFileSessionData } from "../constance/sessionData";
import { fileDeleteRequestType, sessionFileType } from "../constance/typeModel";

export const deleteFile = async (
  entry_id: number,
  file_class: string,
  file_id: number,
  dispatch: Function,
): Promise<void> => {
  const postData: fileDeleteRequestType = {
    file_method: "delete",
    entry_id,
    files: {
      ...initFileSessionData,
      [file_class]: [{ file_id }],
    },
  };
  await PostMethod<fileDeleteRequestType, undefined>(postData, "/file_data");

  const currentFiles = getSession("files");
  const updatedFileList = (currentFiles?.[file_class] ?? []).filter(
    (file: sessionFileType) => file.file_id !== file_id,
  );
  const updatedFiles = {
    ...currentFiles,
    [file_class]: updatedFileList,
  };

  setFileInfoData(updatedFiles);
  dispatch({ type: "set-entry-files", payload: updatedFiles });
};
